<mat-list>
  <ng-container *ngIf="displaySettings$ | async as displaySettings">
    <mat-list-item>
      <div
        class="frame warning"
        mat-line
        *ngIf="!params.newsday && params.scoreevent && checkTimeframe()"
        matTooltip="This event drives the score over a longer period than your selected timeframe, so its articles are shown from the whole scoring window."
      >
        <span>Full score window</span>
      </div>
      <div
        class="frame warning"
        mat-line
        *ngIf="!params.newsday && params.scoreevent && !checkTimeframe()"
      >
        <!--<mat-icon class="flip">warning</mat-icon>-->
        <!--<span>Categories filter disabled</span>-->
      </div>
    </mat-list-item>
    <mat-list-item
      class="story-box"
      [class.scanner-stories]="routing.isScanner()"
      [class.trending-stories]="routing.isHot()"
      *ngFor="let story of stories; index as index"
      [class]="'news-feed-story-item-' + (params.newstype || 'stories')"
    >
      <div
        *ngIf="story && story.size"
        class="frame stories top"
        mat-line
        [matTooltip]="story?.story"
        [class.blur]="story?.article?.reduce_visibility"
        (click)="selectStory(story, story.article, 'feedstories2')"
      >
        <span
          class="story-title"
          [attr.lang]="story.article.lang || null"
          [innerHTML]="story.article.titleFormatted | sanitizeHtml"
        ></span>
      </div>
      <div
        mat-line
        *ngIf="story && story.article && !story.article.hidden"
        class="bloksent bloksent-story box-map story-teaser-container"
        [class.inew]="story.article.inew"
        [matTooltipDisabled]="
          (screenSize$ | async)?.isMobile || routing.isIframe() || fullscreen
        "
        [matTooltip]="getTeaser(story.article)"
        matTooltipPosition="right"
        matTooltipShowDelay="200"
        matTooltipClass="newstooltip"
      >
        <div class="news-container">
          <div
            class="cont"
            (click)="selectStory(story, story.article, 'feedstories2')"
          >
            <div
              class="tito story-teaser"
              [class.blur]="story.article.reduce_visibility"
            >
              <div
                class="story-teaser-inner"
                [attr.lang]="story.article.lang || null"
                [innerHTML]="getTeaser(story.article)"
              ></div>
            </div>
            <div class="subo story-teaser" mat-line>
              <div class="blok">
                <span
                  >{{
                    story.article.publish_time
                      | date: 'dd.MM.yyyy HH:mm' : 'GMT'
                  }}
                  GMT</span
                >
              </div>
              <div class="blok">
                <span> | </span>
              </div>
              <div class="blok blok2" *ngIf="story.article.provider">
                <span class="notranslate">{{ story.article.provider }}</span>
              </div>
              <div
                class="blok icon"
                *ngIf="
                  story.article.document_categorization &&
                  story.article.document_categorization.is_licensed_content
                "
                matTooltip="Licensed content with fulltext"
              >
                <img
                  *ngIf="routing.theme !== 'light'"
                  src="assets/logo/yukka_mobile.svg"
                />
                <img
                  *ngIf="routing.theme === 'light'"
                  src="assets/logo/yukka_mobile_light.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        mat-line
        *ngIf="story && story.size && morenews[index]"
        class="news-group-container"
        [style.max-height.px]="storyContentHeight"
      >
        <ng-container *ngFor="let news of story.news">
          <div
            mat-line
            *ngIf="!news.hidden"
            class="bloksent bloksent-story box-map"
            [class.seen]="
              displaySettings.fadeoutSeen &&
              userActivityApi.seenArticles &&
              userActivityApi.seenArticles.includes(news.id)
            "
            [class.inew]="news.inew"
            [matTooltipDisabled]="
              (screenSize$ | async)?.isMobile ||
              routing.isIframe() ||
              fullscreen
            "
            [matTooltip]="getTeaser(news)"
            matTooltipPosition="right"
            matTooltipShowDelay="200"
            matTooltipClass="newstooltip"
          >
            <div class="news-container">
              <div
                class="cont"
                (click)="selectStory(story, news, 'feedstories')"
              >
                <div class="tito" [class.blur]="news.reduce_visibility">
                  <div class="bullet">&#8226;</div>
                  <div
                    mat-line
                    [attr.lang]="news.lang || null"
                    [innerHTML]="news.titleFormatted | sanitizeHtml"
                  ></div>
                </div>
                <div class="subo" mat-line>
                  <div class="blok">
                    <span
                      >{{
                        news.publish_time | date: 'dd.MM.yyyy HH:mm' : 'GMT'
                      }}
                      GMT</span
                    >
                  </div>
                  <div class="blok">
                    <span> | </span>
                  </div>
                  <div class="blok blok2" *ngIf="news.provider">
                    <span class="notranslate">{{ news.provider }}</span>
                  </div>
                  <div
                    class="blok icon"
                    *ngIf="
                      news.document_categorization &&
                      news.document_categorization.is_licensed_content
                    "
                    matTooltip="Licensed content with fulltext"
                  >
                    <img
                      *ngIf="routing.theme !== 'light'"
                      src="assets/logo/yukka_mobile.svg"
                    />
                    <img
                      *ngIf="routing.theme === 'light'"
                      src="assets/logo/yukka_mobile_light.svg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="story && story.size" class="frame stories bottom" mat-line>
        <div class="more-info" (click)="getMoreNews(story, index)">
          <mat-icon *ngIf="!morenews[index]">arrow_drop_down</mat-icon>
          <mat-icon *ngIf="morenews[index]">arrow_drop_up</mat-icon>
        </div>
        <div class="story-info" (click)="getMoreNews(story, index)">
          <span>
            {{ story.size + ' ' + (story.size === 1 ? 'Article' : 'Articles') }}
          </span>
        </div>
      </div>
    </mat-list-item>
  </ng-container>
</mat-list>
